import styles from './styles.module.css';
import Header, { HeaderProps } from '@/components/atoms/Header';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import { theme } from '@/styles/theme';
import Image from 'next/image';
import logo_chippu_place from '@/assets/logo_chippu_place.svg';

export default function CabecalhoComBotaoVoltarFallback(props: HeaderProps) {
  return (
    <Header {...props}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div
          className={styles.button}
          style={{
            borderRadius: theme.spacing[1],
            paddingTop: theme.spacing[1],
            paddingRight: theme.spacing[2],
            paddingBottom: theme.spacing[1],
            paddingLeft: theme.spacing[2],
            gap: theme.spacing[2],
            color: theme.colors.neutral.neutral[12],
            fontSize: theme.typography.font.size[2],
            fontWeight: theme.typography.font.weight.medium,
            lineHeight: `${theme.typography.font.line_height[2]}px`,
          }}
        >
          <IconeSeta
            size={theme.typography.font.size[5]}
            color={theme.colors.neutral.neutral[12]}
            direcao="esquerda"
          />
          Voltar
        </div>
        <Image
          src={logo_chippu_place}
          alt="Chippu Place logo"
          height={theme.typography.font.size[7]}
          priority
          style={{
            marginRight: theme.spacing[4],
          }}
        />
      </div>
    </Header>
  );
}
